import Axios from "axios";
import { API_URL_UMS } from "../Constant";

export const authorizedMessage = "User not authorized !";

async function permission(params) {
  const userID = JSON.parse(localStorage.getItem("userData")).userId;
  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
      "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
    },
  };
  let response = await Axios.get(`${API_URL_UMS}/resources/checkAuthorization?userName=${userID}&permission=${params}`, requestOptions)
  return response
}

export async function isPermission(params) {
  let data = await permission(params)
  return data.data
}


